import React, { useState, useEffect } from "react";
import Styles from "./UserInput.module.css";
import { useNavigate } from "react-router-dom";
import ShowOver from "../showoverlay/ShowOver";
import realmeimg from "../../assets/Realmeunit.png";
import fklogo from "../../assets/fklogo.png";
import logo from "../../assets/Swayambhu.png";
import logonew from "../../assets/logo.png";
import axios from "axios";

const host = "https://backend.annualcreditconference.in";
// const host = "http://localhost:8080";

const UserInput = (props) => {
  const [image, setImage] = useState(null);
  // const [responseData, setResponseData] = useState(null);

  const [showOverlay, setShowOverlay] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const navigation = useNavigate();

  useEffect(() => {
    setImage(props.image);
  }, [props.image]);

  const retakehandler = () => {
    navigation("/home");
  };

  const downloadImage = async () => {
    try {
      setShowOverlay(true);
      setUploadProgress(0);

      // Start fake progress (0 to 90%)
      let progress = 0;
      const interval = setInterval(() => {
        progress += 1;
        if (progress < 90) {
          setUploadProgress(progress);
        }
      }, 50);

      const formData = new FormData();
      formData.append("name", "");
      formData.append("email", "");
      formData.append("number", "");
      formData.append("image", image);

      const response = await fetch(`${host}/upload`, {
        method: "POST",
        body: formData,
      });

      const fresponse = await response.json();

      clearInterval(interval); // stop fake progress
      setUploadProgress(100); // finish it

      // Add a slight pause for visual smoothness
      setTimeout(() => {
        if (response.ok) {
          props.responsedata(fresponse.s3Urls);
          navigation("/gallery");
        } else {
          console.error("Upload failed");
        }

        setShowOverlay(false);
      }, 500); // 0.5s delay after 100% shown
    } catch (error) {
      console.error("Upload error:", error);
      setShowOverlay(false);
    }
  };

  const showoverlayhandler = () => {
    setShowOverlay(false);
  };

  const catchdata = (data) => {
    // setResponseData(data)
    // console.log(data)
    props.responsedata(data);
  };

  return (
    <>
      {showOverlay && (
        <ShowOver
          image={image}
          close={showoverlayhandler}
          responsedata={catchdata}
          uploadProgress={uploadProgress}
        />
      )}
      <div className={`${Styles.userinput_container}`}>
        {/* <h1 style={{fontWeight: "300",}}>Realme 11 Pro+ 5G</h1> */}
        <img
          src={logonew}
          alt="Logo"
          className="w-56 sm:w-68 md:w-72 lg:w-[600px] xl:w-96"
        />{" "}
        {/* <h4 className={`${Styles.presenttitle}`}>presents</h4> */}
        {/* <h2 className={`${Styles.superstartitle}`}>Face Finder</h2> */}
        <div className={`${Styles.main_div}`}>
          <div className={`${Styles.img_div}`}>
            <img
              src={image}
              // src="https://images.unsplash.com/photo-1552374196-c4e7ffc6e126?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8c2VsZmllfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60"
              className={`${Styles.img}`}
              alt=""
            />
          </div>
          <div className="flex justify-around items-center gap-4 mt-6">
            <button
              onClick={retakehandler}
              className="
              w-full
      px-6 py-3
      bg-[#5a5a5a]
      text-white text-base sm:text-lg md:text-xl lg:text-2xl
      font-semibold rounded-full
      shadow-[0_4px_10px_rgba(90,90,90,0.3)]
      transition-all duration-300 ease-in-out
      hover:shadow-[0_6px_18px_rgba(90,90,90,0.5)]
      hover:scale-105 active:scale-95
      h-12 sm:h-14 md:h-16
    "
            >
              Retake
            </button>

            <button
              onClick={downloadImage}
              className="
              w-full
      px-6 py-3
      bg-[#0077b6]
      text-white text-base sm:text-lg md:text-xl lg:text-2xl
      font-semibold rounded-full
      shadow-[0_4px_10px_rgba(0,119,182,0.3)]
      transition-all duration-300 ease-in-out
      hover:shadow-[0_6px_18px_rgba(0,119,182,0.5)]
      hover:scale-105 active:scale-95
      h-12 sm:h-14 md:h-16
    "
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserInput;
